import { render, staticRenderFns } from "./NewBlog.vue?vue&type=template&id=40927834&scoped=true"
import script from "./NewBlog.vue?vue&type=script&lang=js"
export * from "./NewBlog.vue?vue&type=script&lang=js"
import style0 from "./NewBlog.vue?vue&type=style&index=0&id=40927834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40927834",
  null
  
)

export default component.exports